var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/internal/engine/ethereum.ts
import { logs } from "named-logs";
var namedLogger = logs("ethereum-utils");
function getBlockNumber(provider) {
  return __async(this, null, function* () {
    const blockAsHexString = yield provider.request({ method: "eth_blockNumber" });
    return parseInt(blockAsHexString.slice(2), 16);
  });
}
function getBlockData(provider, hash) {
  return __async(this, null, function* () {
    const blockWithHexStringFields = yield provider.request({ method: "eth_getBlockByHash", params: [hash, false] });
    if (!blockWithHexStringFields) {
      throw new Error(`could not fetch block`);
    }
    return {
      timestamp: parseInt(blockWithHexStringFields.timestamp.slice(2), 16)
    };
  });
}
function getBlockDataFromMultipleHashes(provider, hashes) {
  return __async(this, null, function* () {
    const requests = [];
    for (const hash of hashes) {
      requests.push({
        method: "eth_getBlockByHash",
        params: [hash, false]
      });
    }
    const blocksWithHexStringFields = yield provider.request({
      method: "eth_batch",
      params: requests
    });
    return blocksWithHexStringFields.map((block) => ({
      timestamp: parseInt(block.timestamp.slice(2), 16)
    }));
  });
}
function getTransactionData(provider, hash) {
  return __async(this, null, function* () {
    const transactionReceiptWithHexStringFields = yield provider.request({
      method: "eth_getTransactionReceipt",
      params: [hash]
    });
    if (!transactionReceiptWithHexStringFields) {
      throw new Error(`could not fetch receipt`);
    }
    return {
      from: transactionReceiptWithHexStringFields.from,
      gasUsed: parseInt(transactionReceiptWithHexStringFields.gasUsed.slice(2), 16),
      effectiveGasPrice: transactionReceiptWithHexStringFields.effectiveGasPrice
    };
  });
}
function getTransactionDataFromMultipleHashes(provider, hashes) {
  return __async(this, null, function* () {
    const requests = [];
    for (const hash of hashes) {
      requests.push({
        method: "eth_getTransactionReceipt",
        params: [hash]
      });
    }
    const transactionReceiptsWithHexStringFields = yield provider.request({ method: "eth_batch", params: requests });
    return transactionReceiptsWithHexStringFields.map((transaction) => {
      return {
        from: transaction.from,
        gasUsed: parseInt(transaction.gasUsed.slice(2), 16),
        effectiveGasPrice: transaction.effectiveGasPrice
        // value: transaction.value
      };
    });
  });
}
function generateLogRequestForTopicsAndFiltersCombinations(contractAddresses, eventNameTopics, filters) {
  if (!filters) {
    return [{ topics: [eventNameTopics], contractAddresses }];
  } else {
    const sharedRequest = { topics: [], contractAddresses };
    const moreRequests = [];
    for (const eventNameTopic of eventNameTopics) {
      const filtersPerEventTopic = filters[eventNameTopic];
      if (filtersPerEventTopic) {
        for (const filter of filtersPerEventTopic.list) {
          moreRequests.push({
            topics: [eventNameTopic, ...filter],
            contractAddresses: filtersPerEventTopic.contractAddresses || contractAddresses
          });
        }
      } else {
        sharedRequest.topics.push(eventNameTopic);
      }
    }
    if (sharedRequest.topics.length > 0) {
      return [sharedRequest, ...moreRequests];
    } else {
      return moreRequests;
    }
  }
}
function getLogsWithVariousFilters(provider, contractAddresses, eventNameTopics, filters, options, unlessCancelled) {
  return __async(this, null, function* () {
    if (!eventNameTopics) {
      return getLogs(provider, contractAddresses, eventNameTopics ? [eventNameTopics] : null, options);
    }
    const requestList = generateLogRequestForTopicsAndFiltersCombinations(
      contractAddresses,
      eventNameTopics,
      filters ? filters : void 0
    );
    const logs3 = [];
    for (const request of requestList) {
      const tmpLogs = yield unlessCancelled(getLogs(provider, request.contractAddresses, request.topics, options));
      logs3.push(...tmpLogs);
    }
    const sortedLogs = logs3.sort((a, b) => {
      const aT = parseInt(a.blockNumber.slice(2), 16);
      const bT = parseInt(b.blockNumber.slice(2), 16);
      if (aT > bT) {
        return 1;
      } else if (aT < bT) {
        return -1;
      } else {
        const aL = parseInt(a.logIndex.slice(2), 16);
        const bL = parseInt(b.logIndex.slice(2), 16);
        if (aL > bL) {
          return 1;
        } else if (aL < bL) {
          return -1;
        } else {
          return 0;
        }
      }
    });
    const logsToReturn = [];
    let lastAdded;
    for (const sortedLog of sortedLogs) {
      if (lastAdded && sortedLog.blockHash === lastAdded.blockHash && sortedLog.logIndex === lastAdded.logIndex) {
        continue;
      }
      lastAdded = sortedLog;
      logsToReturn.push(sortedLog);
    }
    return logsToReturn;
  });
}
function getLogs(provider, contractAddresses, topics, options) {
  return __async(this, null, function* () {
    const logs3 = yield provider.request({
      method: "eth_getLogs",
      params: [
        {
          address: contractAddresses ? contractAddresses : void 0,
          fromBlock: "0x" + options.fromBlock.toString(16),
          toBlock: "0x" + options.toBlock.toString(16),
          topics: topics ? topics : void 0
        }
      ]
    });
    return logs3.filter((v) => v.blockNumber !== null);
  });
}

// src/indexer.ts
import { logs as logs2 } from "named-logs";

// src/internal/engine/LogFetcher.ts
function getNewToBlockFromError(error) {
  if (error.code === -32005 || error.code === -32602 && error.message) {
    if (error.message.startsWith("query returned more than 10000 results.")) {
      console.error(error.message);
    }
    const regex = /\[.*\]/gm;
    const result = regex.exec(error.message);
    let values;
    if (result && result[0]) {
      values = result[0].slice(1, result[0].length - 1).split(", ").map((v) => parseInt(v.slice(2), 16));
    }
    if (values && !isNaN(values[1])) {
      return values[1];
    }
  }
  return void 0;
}
var LogFetcher = class {
  constructor(provider, contractAddresses, eventNameTopics, conf = {}) {
    this.provider = provider;
    this.contractAddresses = contractAddresses;
    this.eventNameTopics = eventNameTopics;
    this.conf = conf;
    this.config = Object.assign(
      {
        numBlocksToFetchAtStart: 50,
        percentageToReach: 80,
        maxEventsPerFetch: 1e4,
        maxBlocksPerFetch: 1e5,
        numRetry: 3
      },
      conf
    );
    this.numBlocksToFetch = Math.min(this.config.numBlocksToFetchAtStart, this.config.maxBlocksPerFetch);
  }
  getLogs(options, unlessCancelled) {
    return __async(this, null, function* () {
      let retry = options.retry !== void 0 ? options.retry : this.config.numRetry;
      let logs3;
      const fromBlock = options.fromBlock;
      let toBlock = Math.min(options.toBlock, fromBlock + this.numBlocksToFetch - 1);
      try {
        if (this.conf.filters) {
          logs3 = yield getLogsWithVariousFilters(
            this.provider,
            this.contractAddresses,
            this.eventNameTopics,
            this.conf.filters,
            {
              fromBlock,
              toBlock
            },
            unlessCancelled
          );
        } else {
          logs3 = yield unlessCancelled(
            getLogs(this.provider, this.contractAddresses, this.eventNameTopics ? [this.eventNameTopics] : null, {
              fromBlock,
              toBlock
            })
          );
        }
      } catch (err) {
        if (retry <= 0) {
          throw err;
        }
        let numBlocksToFetchThisTime = this.numBlocksToFetch;
        const toBlockClue = getNewToBlockFromError(err);
        if (toBlockClue) {
          const totalNumOfBlocksToFetch = toBlockClue - fromBlock + 1;
          if (totalNumOfBlocksToFetch > 1) {
            numBlocksToFetchThisTime = Math.floor(totalNumOfBlocksToFetch * this.config.percentageToReach / 100);
          }
        } else {
          const totalNumOfBlocksThatWasFetched2 = toBlock - fromBlock;
          if (err.code === -32603 && err.data && err.data.message && err.data.message.indexOf("block range is too wide") !== -1) {
            this.foundNumBlockToHigh = Math.min(
              this.foundNumBlockToHigh || this.config.maxBlocksPerFetch,
              totalNumOfBlocksThatWasFetched2
            );
          }
          if (totalNumOfBlocksThatWasFetched2 > 1) {
            numBlocksToFetchThisTime = Math.floor(totalNumOfBlocksThatWasFetched2 / 2);
          } else {
            numBlocksToFetchThisTime = 1;
          }
        }
        this.numBlocksToFetch = numBlocksToFetchThisTime;
        if (this.foundNumBlockToHigh && this.foundNumBlockToHigh < this.numBlocksToFetch) {
          if (this.safeNumBlock) {
            this.numBlocksToFetch = Math.min(
              Math.floor((this.foundNumBlockToHigh - this.safeNumBlock) / 2),
              this.foundNumBlockToHigh - 1
            );
          } else {
            this.numBlocksToFetch = this.foundNumBlockToHigh - 1;
          }
        }
        toBlock = fromBlock + this.numBlocksToFetch - 1;
        const result = yield this.getLogs(
          {
            fromBlock,
            toBlock,
            retry: retry - 1
          },
          unlessCancelled
        );
        logs3 = result.logs;
        toBlock = result.toBlockUsed;
      }
      const targetNumberOfLog = Math.max(
        1,
        Math.floor(this.config.maxEventsPerFetch * this.config.percentageToReach / 100)
      );
      const totalNumOfBlocksThatWasFetched = toBlock - fromBlock + 1;
      this.safeNumBlock = Math.max(this.safeNumBlock || 0, totalNumOfBlocksThatWasFetched);
      if (this.foundNumBlockToHigh) {
        if (this.safeNumBlock) {
          this.numBlocksToFetch = Math.min(
            this.safeNumBlock + Math.floor((this.foundNumBlockToHigh - this.safeNumBlock) / 2),
            this.foundNumBlockToHigh - 1
          );
        } else {
          this.numBlocksToFetch = this.foundNumBlockToHigh - 1;
        }
      } else {
        if (logs3.length === 0) {
          this.numBlocksToFetch = this.config.maxBlocksPerFetch;
        } else {
          this.numBlocksToFetch = Math.min(
            this.config.maxBlocksPerFetch,
            Math.max(1, Math.floor(targetNumberOfLog * totalNumOfBlocksThatWasFetched / logs3.length))
          );
        }
      }
      return { logs: logs3, toBlockUsed: toBlock };
    });
  }
};

// src/internal/decoding/LogEventFetcher.ts
import { decodeEventLog, encodeEventTopics } from "viem";

// src/internal/utils/compare.ts
function deepEqual(a, b) {
  if (typeof a == "object" && a != null && typeof b == "object" && b != null) {
    let numKeysInA = 0;
    let numKeysinB = 0;
    for (const key in a) {
      numKeysInA++;
    }
    for (const key in b) {
      numKeysinB++;
    }
    if (numKeysInA !== numKeysinB) {
      return false;
    }
    for (const key in a) {
      if (!(key in b) || !deepEqual(a[key], b[key])) {
        return false;
      }
    }
    for (const key in b) {
      if (!(key in a) || !deepEqual(b[key], a[key])) {
        return false;
      }
    }
    return true;
  } else {
    return a === b;
  }
}

// src/internal/utils/address.ts
import { getAddress } from "viem";
function normalizeAddress(addr) {
  return getAddress(addr);
}

// src/internal/decoding/LogEventFetcher.ts
function deleteDuplicateEvents(events, failOnIdenticalNameButDifferentInputs) {
  const map = /* @__PURE__ */ new Map();
  for (let i = 0; i < events.length; i++) {
    const event = events[i];
    const namedEvent = map.get(event.name);
    if (!namedEvent) {
      map.set(event.name, event);
    } else {
      if (failOnIdenticalNameButDifferentInputs) {
        if (!deepEqual(event.inputs, namedEvent.inputs)) {
          throw new Error(`two events with same name but different inputs`);
        }
      }
      events.splice(i, 1);
      i--;
    }
  }
}
var LogEventFetcher = class extends LogFetcher {
  constructor(provider, contractsData, fetcherConfig = {}, parseConfig) {
    const _abiEventPerTopic = /* @__PURE__ */ new Map();
    const _nameToTopic = /* @__PURE__ */ new Map();
    const _abiPerAddress = /* @__PURE__ */ new Map();
    const _eventNameToContractAddresses = /* @__PURE__ */ new Map();
    const _allABIEvents = [];
    let contractAddresses = null;
    if (Array.isArray(contractsData)) {
      contractAddresses = [];
      for (const contract of contractsData) {
        const contractAddress = normalizeAddress(contract.address);
        const contractEventsABI = contract.abi.filter((item) => item.type === "event");
        const abiAtThatAddress = _abiPerAddress.get(contractAddress);
        if (!abiAtThatAddress) {
          _abiPerAddress.set(contractAddress, contractEventsABI);
          contractAddresses.push(contractAddress);
        } else {
          abiAtThatAddress.push(...contractEventsABI);
          deleteDuplicateEvents(abiAtThatAddress, true);
        }
        _allABIEvents.push(...contractEventsABI);
        for (const event of contractEventsABI) {
          const list = _eventNameToContractAddresses.get(event.name) || [];
          if (list.length === 0) {
            _eventNameToContractAddresses.set(event.name, list);
          }
          if (list.indexOf(contractAddress) === -1) {
            list.push(contractAddress);
          }
        }
      }
    } else {
      const allContractsData = contractsData;
      _allABIEvents.push(...allContractsData.abi.filter((item) => item.type === "event"));
    }
    deleteDuplicateEvents(_allABIEvents, false);
    const eventNameTopics = [];
    for (const item of _allABIEvents) {
      const topics = encodeEventTopics({
        abi: _allABIEvents,
        eventName: item.name
      });
      if (topics.length > 0) {
        _nameToTopic.set(item.name, topics[0]);
      }
      for (const v of topics) {
        if (!_abiEventPerTopic.get(v)) {
          _abiEventPerTopic.set(v, item);
          eventNameTopics.push(v);
        } else {
          throw new Error(`duplicate topics found`);
        }
      }
    }
    if (parseConfig == null ? void 0 : parseConfig.filters) {
      const filters = {};
      for (const eventName of Object.keys(parseConfig.filters)) {
        const filterList = parseConfig.filters[eventName];
        const signatureTopic = _nameToTopic.get(eventName);
        if (signatureTopic) {
          filters[signatureTopic] = {
            list: filterList,
            contractAddresses: _eventNameToContractAddresses.get(eventName)
          };
        }
      }
      fetcherConfig = __spreadProps(__spreadValues({}, fetcherConfig), { filters });
    }
    super(provider, contractAddresses, eventNameTopics, fetcherConfig);
    this.provider = provider;
    this.contractsData = contractsData;
    this.fetcherConfig = fetcherConfig;
    this.parseConfig = parseConfig;
    this.allABIEvents = _allABIEvents;
    this.abiPerAddress = _abiPerAddress;
    this.abiEventPerTopic = _abiEventPerTopic;
  }
  getLogEvents(options, unlessCancelled) {
    return __async(this, null, function* () {
      const { logs: logs3, toBlockUsed } = yield this.getLogs(options, unlessCancelled);
      const events = this.parse(logs3);
      return { events, toBlockUsed };
    });
  }
  parse(logs3) {
    var _a, _b;
    const events = [];
    for (let i = 0; i < logs3.length; i++) {
      const log = logs3[i];
      const eventAddress = normalizeAddress(log.address);
      const event = {
        blockNumber: parseInt(log.blockNumber.slice(2), 16),
        blockHash: log.blockHash,
        transactionIndex: parseInt(log.transactionIndex.slice(2), 16),
        removed: log.removed ? true : false,
        address: eventAddress,
        data: log.data,
        topics: log.topics,
        transactionHash: log.transactionHash,
        logIndex: parseInt(log.logIndex.slice(2), 16)
      };
      const useAllABIEvents = this.abiPerAddress.size === 0 || ((_a = this.parseConfig) == null ? void 0 : _a.parseAllEventsIrrespectiveOfAddresses);
      const correspondingABI = useAllABIEvents ? this.allABIEvents : this.abiPerAddress.get(eventAddress);
      if (correspondingABI) {
        let parsed = null;
        try {
          parsed = decodeEventLog({
            abi: correspondingABI,
            data: log.data,
            topics: log.topics
          });
        } catch (err) {
          parsed = null;
          event.decodeError = `decoding error: ${err}`;
        }
        if (parsed) {
          event.args = parsed.args;
          event.eventName = parsed.eventName;
        } else {
          event.decodeError = `parsing did not return any results`;
        }
      } else {
        event.decodeError = `event triggered at a different address`;
      }
      if ((_b = this.parseConfig) == null ? void 0 : _b.logValues) {
        const eventWithFilteredValues = {};
        if (event.args) {
          eventWithFilteredValues.args = event.args;
        }
        for (const key of Object.keys(this.parseConfig.logValues)) {
          if (typeof event[key] !== "undefined") {
            eventWithFilteredValues[key] = event[key];
          }
        }
        events.push(eventWithFilteredValues);
      } else {
        events.push(event);
      }
    }
    return events;
  }
};

// src/internal/engine/utils.ts
function wait(seconds) {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1e3));
}
function groupLogsPerBlock(logEvents) {
  const groups = {};
  const logEventsGroupedPerBlock = [];
  for (const event of logEvents) {
    if (event.removed) {
      continue;
    }
    let group = groups[event.blockHash];
    if (!group) {
      group = groups[event.blockHash] = {
        hash: event.blockHash,
        number: event.blockNumber,
        events: []
      };
      logEventsGroupedPerBlock.push(group);
    }
    group.events.push(event);
  }
  return logEventsGroupedPerBlock;
}
function generateStreamToAppend(lastSync, defaultFromBlock, newEvents, {
  newLatestBlock,
  newLastFromBlock,
  newLastToBlock,
  finality
}) {
  const expectedFromBlock = getFromBlock(lastSync, defaultFromBlock, finality);
  if (newLastFromBlock !== expectedFromBlock) {
    let message = `fromBlock (${newLastFromBlock}) not as expected (${expectedFromBlock}).`;
    if (newLastFromBlock > expectedFromBlock) {
      message += `
This is too far back, we could trim it automatically, but this is probably an error to send that, so we throw here`;
    } else {
      message += `
The fromBlock do not consider the potential of reorg, the only safe fromBlock is ${expectedFromBlock}`;
    }
    throw new Error(message);
  }
  const logEventsGroupedPerBlock = groupLogsPerBlock(newEvents);
  const eventStream = [];
  const lastUnconfirmedBlocks = lastSync.unconfirmedBlocks;
  let reorgBlock;
  let reorgedBlockIndex = 0;
  for (const block of logEventsGroupedPerBlock) {
    if (reorgedBlockIndex < lastUnconfirmedBlocks.length) {
      const unconfirmedBlockAtIndex = lastUnconfirmedBlocks[reorgedBlockIndex];
      if (unconfirmedBlockAtIndex.hash !== block.hash) {
        reorgBlock = unconfirmedBlockAtIndex;
        break;
      }
      reorgedBlockIndex++;
    } else {
      break;
    }
  }
  if (reorgBlock) {
    for (let i = reorgedBlockIndex; i < lastUnconfirmedBlocks.length; i++) {
      for (const event of lastUnconfirmedBlocks[i].events) {
        eventStream.push(__spreadProps(__spreadValues({}, event), {
          removed: true
        }));
      }
    }
  }
  const startingBlockForNewEvent = reorgBlock ? reorgBlock.number : lastUnconfirmedBlocks.length > 0 ? lastUnconfirmedBlocks[lastUnconfirmedBlocks.length - 1].number + 1 : logEventsGroupedPerBlock.length > 0 ? logEventsGroupedPerBlock[0].number : 0;
  const newUnconfirmedBlocks = [];
  for (const unconfirmedBlock of lastUnconfirmedBlocks) {
    if (unconfirmedBlock.number < startingBlockForNewEvent) {
      if (newLastToBlock - unconfirmedBlock.number <= finality) {
        newUnconfirmedBlocks.push(unconfirmedBlock);
      }
    }
  }
  for (const block of logEventsGroupedPerBlock) {
    const isUnconfirmedBlock = newLatestBlock - block.number <= finality;
    if (block.events.length > 0 && block.number >= startingBlockForNewEvent) {
      const newEventsPerBlock = [];
      for (const event of block.events) {
        eventStream.push(event);
        if (isUnconfirmedBlock) {
          newEventsPerBlock.push(__spreadValues({}, event));
        }
      }
      if (isUnconfirmedBlock) {
        newUnconfirmedBlocks.push({
          hash: block.hash,
          number: block.number,
          events: newEventsPerBlock
        });
      }
    }
  }
  return {
    eventStream,
    newLastSync: {
      context: lastSync.context,
      lastFromBlock: newLastFromBlock,
      latestBlock: newLatestBlock,
      lastToBlock: newLastToBlock,
      unconfirmedBlocks: newUnconfirmedBlocks
    }
  };
}
function getFromBlock(lastSync, defaultFromBlock, finality) {
  return lastSync.latestBlock === 0 ? defaultFromBlock : Math.max(Math.min(lastSync.lastToBlock + 1, lastSync.latestBlock - finality), 0);
}

// src/internal/utils/promises.ts
var CancellablePromiseCancelled = class extends Error {
  constructor() {
    super("CancellablePromiseCancelled");
  }
};
function createCancellablePromise(executor, onCancel) {
  let resolve;
  let reject;
  let cancelled = false;
  let completed = false;
  function rejectIfNotCancelledAlready(err) {
    if (!cancelled && !completed) {
      completed = true;
      reject(err);
    }
  }
  function resolveIfNotCancelledAlready(result) {
    if (!cancelled && !completed) {
      completed = true;
      resolve(result);
    }
  }
  function cancel() {
    if (!cancelled) {
      cancelled = true;
      reject(new CancellablePromiseCancelled());
      if (onCancel) {
        onCancel();
      }
    }
  }
  function unlessCancelled(p) {
    return p.then((v) => {
      if (cancelled) {
        throw new CancellablePromiseCancelled();
      } else {
        return v;
      }
    });
  }
  const promise = new Promise((a, b) => {
    resolve = a;
    reject = b;
    executor(
      resolveIfNotCancelledAlready,
      rejectIfNotCancelledAlready,
      unlessCancelled,
      cancel
    );
  });
  promise.cancel = cancel;
  Object.defineProperty(promise, "cancelled", {
    get: function() {
      return cancelled;
    }
  });
  Object.defineProperty(promise, "completed", {
    get: function() {
      return completed;
    }
  });
  return promise;
}
function createAction(execute) {
  let _context;
  let _promise;
  let _blocked = false;
  function _execute(mode = "wait", args) {
    if (_blocked) {
      throw new Error("Blocked");
    }
    if (_promise) {
      if (_promise.completed) {
        if (mode === "once") {
          return _promise;
        }
      } else if (!_promise.cancelled) {
        if (mode === "force") {
          _promise.cancel();
        } else if (mode === "queue") {
          const p = _promise;
          _promise = _promise.then(() => {
            return createCancellablePromise(
              (resolve, reject, unlessCancelled, cancel) => {
                const promiseAction = { resolve, reject, unlessCancelled, cancel };
                const result = execute(args ? args : promiseAction, args ? promiseAction : void 0);
                if (result) {
                  result.then(resolve).catch(reject);
                }
              },
              () => {
                p.cancel();
              }
            );
          });
        } else {
          return _promise;
        }
      }
    }
    _context = void 0;
    _promise = createCancellablePromise((resolve, reject, unlessCancelled, cancel) => {
      const promiseAction = { resolve, reject, unlessCancelled, cancel };
      const result = execute(args ? args : promiseAction, args ? promiseAction : void 0);
      if (result) {
        result.then(resolve).catch(reject);
      }
    });
    return _promise;
  }
  return {
    next: (args) => _execute("queue", args),
    ifNotExecuting: (args) => _execute("wait", args),
    // ifNotExecuting args is ignored if first execited
    now: (args) => _execute("force", args),
    once: (args) => _execute("once", args),
    // once args is ignored if first execited
    cancel() {
      _promise == null ? void 0 : _promise.cancel();
    },
    block() {
      _promise == null ? void 0 : _promise.cancel();
      _blocked = true;
    },
    unblock() {
      _blocked = false;
    },
    reset() {
      if (_promise) {
        _promise == null ? void 0 : _promise.cancel();
      }
      _promise = void 0;
    },
    get executing() {
      if ((_promise == null ? void 0 : _promise.completed) || (_promise == null ? void 0 : _promise.cancelled)) {
        return void 0;
      }
      return _promise;
    },
    setContext(context) {
      _context = context;
    },
    getContext() {
      return _context;
    }
  };
}

// src/utils/hash.ts
function normalizeAsArray(obj) {
  if (obj === null) {
    return null;
  }
  if (Array.isArray(obj)) {
    return obj.map((v) => normalizeAsArray(v));
  } else if (typeof obj === "object") {
    const arr = [];
    const keys = Object.keys(obj).sort();
    for (const key of keys) {
      const value = obj[key];
      if (value) {
        arr.push([key, normalizeAsArray(value)]);
      }
    }
    return arr;
  } else {
    return obj;
  }
}
function simple_hash(obj) {
  const str = typeof obj === "string" ? obj : JSON.stringify(normalizeAsArray(obj)).replace(/\s+/g, "");
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash;
  }
  const result = new Uint32Array([hash])[0].toString(36);
  return result;
}

// src/indexer.ts
var namedLogger2 = logs2("ethereum-indexer");
var EthereumIndexer = class {
  // ------------------------------------------------------------------------------------------------------------------
  // CONSTRUCTOR
  // ------------------------------------------------------------------------------------------------------------------
  constructor(provider, processor, source, config = {}) {
    this.processor = processor;
    // ------------------------------------------------------------------------------------------------------------------
    // ACTIONS
    // ------------------------------------------------------------------------------------------------------------------
    this._index = createAction(this.promiseToIndex.bind(this));
    this._feed = createAction(
      this.promiseToFeed.bind(this)
    );
    this._load = createAction(this.promiseToLoad.bind(this));
    this._save = createAction(this.promiseToSave.bind(this));
    this.reinit(provider, source, config);
  }
  reinit(provider, source, config) {
    var _a;
    this.provider = provider;
    this.source = source;
    this.sourceHashes = [{ startBlock: 0, hash: simple_hash(this.source) }];
    const streamConfig = __spreadValues({ finality: 17 }, config.stream || {});
    this.config = __spreadProps(__spreadValues({ feedBatchSize: 300 }, config), { stream: streamConfig });
    this.streamConfigHash = simple_hash(this.config.stream || "undefined");
    this.finality = this.config.stream.finality;
    this.logEventFetcher = new LogEventFetcher(this.provider, source.contracts, config == null ? void 0 : config.fetch, (_a = config.stream) == null ? void 0 : _a.parse);
    let fromBlockFromContracts;
    if (Array.isArray(this.source.contracts)) {
      for (const contractData of this.source.contracts) {
        if (contractData.startBlock) {
          if (fromBlockFromContracts === void 0 || contractData.startBlock < fromBlockFromContracts) {
            fromBlockFromContracts = contractData.startBlock;
          }
        } else {
          fromBlockFromContracts = 0;
        }
      }
    } else {
      fromBlockFromContracts = this.source.contracts.startBlock || 0;
    }
    this.defaultFromBlock = fromBlockFromContracts || 0;
  }
  // ------------------------------------------------------------------------------------------------------------------
  // PUBLIC INTERFACE
  // ------------------------------------------------------------------------------------------------------------------
  load() {
    if (this._index.executing) {
      throw new Error(`indexing... should not load`);
    }
    if (this._feed.executing) {
      throw new Error(`feeding... should not load`);
    }
    return this._load.once();
  }
  feed(eventStream, lastSyncFetched) {
    return __async(this, null, function* () {
      if (this._index.executing) {
        throw new Error(`indexing... should not feed`);
      }
      if (this._feed.executing) {
        throw new Error(`already feeding... should not feed`);
      }
      return this._feed.next({
        newEvents: eventStream,
        lastSyncFetched: lastSyncFetched || this.freshLastSync(this.processor.getVersionHash())
      });
    });
  }
  indexMore() {
    if (this._load.executing) {
      throw new Error(`loading not complete`);
    }
    if (this._feed.executing) {
      throw new Error(`feed is not complete`);
    }
    return this._index.ifNotExecuting();
  }
  disableProcessing() {
    this._load.cancel();
    this._feed.cancel();
    this._index.block();
  }
  reenableProcessing() {
    this._index.unblock();
  }
  updateIndexer(update) {
    return __async(this, null, function* () {
      var _a;
      this.disableProcessing();
      const newConfigHash = update.streamConfig ? simple_hash(update.streamConfig) : this.streamConfigHash;
      const newSourceHashes = update.source ? [{ startBlock: 0, hash: simple_hash(update.source) }] : this.sourceHashes;
      const newProvider = update.provider || this.provider;
      const oldSource = this.source;
      const processorVersionHash = this.processor.getVersionHash();
      const resetNeeded = !indexerMatches(newSourceHashes, newConfigHash, 0, {
        source: this.sourceHashes,
        config: this.streamConfigHash,
        processor: processorVersionHash
      });
      if (!resetNeeded) {
        const newChainIdAsHex = yield newProvider.request({ method: "eth_chainId" });
        const newChainId = parseInt(newChainIdAsHex.slice(2), 16).toString();
        if (newChainId !== oldSource.chainId) {
          throw new Error(
            `
					Connected to a different chain (chainId : ${newChainId}) than the previous indexer conext (${oldSource.chainId}).
					Indexer should reset.
					Did you forget to pass some new source?
					`
          );
        }
      } else {
        if (((_a = this.config) == null ? void 0 : _a.logLevel) && this.config.logLevel >= 1) {
          console.log(`updateIndexer: Reset needed, Indexer do not match`, {
            newSourceHashes,
            newConfigHash,
            sourceHashes: this.sourceHashes,
            streamConfigHash: this.streamConfigHash,
            processorVersionHash
          });
        }
      }
      this._feed.reset();
      this._index.reset();
      this._save.reset();
      this._load.reset();
      this.reinit(
        newProvider,
        update.source || this.source,
        update.streamConfig ? __spreadProps(__spreadValues({}, this.config), { stream: update.streamConfig }) : this.config
      );
      if (resetNeeded) {
        yield this.processor.reset().then((v) => this.load()).then(() => this.reenableProcessing());
      } else {
        this.reenableProcessing();
      }
    });
  }
  updateProcessor(newProcessor) {
    return __async(this, null, function* () {
      const oldProcessor = this.processor;
      this.processor = newProcessor;
      if (oldProcessor.getVersionHash() != newProcessor.getVersionHash()) {
        if (this._index.executing) {
          this._index.cancel();
        }
        if (this._feed.executing) {
          this._feed.cancel();
        }
        this._load.reset();
        yield oldProcessor.clear().then(() => this.load());
      }
    });
  }
  reset() {
    return __async(this, null, function* () {
      var _a;
      if (this._index.executing) {
        this._index.cancel();
      }
      if (this._feed.executing) {
        this._feed.cancel();
      }
      this._load.reset();
      yield (_a = this.config.keepStream) == null ? void 0 : _a.clear(this.source);
      yield this.processor.clear().then(() => this.load());
    });
  }
  // ------------------------------------------------------------------------------------------------------------------
  // INTERNALS
  // ------------------------------------------------------------------------------------------------------------------
  save(source, eventStream, lastSync) {
    return __async(this, null, function* () {
      return this._save.next({ source, eventStream, lastSync });
    });
  }
  promiseToLoad() {
    return __async(this, null, function* () {
      var _a;
      const chainId = yield this.provider.request({ method: "eth_chainId" });
      if (parseInt(chainId.slice(2), 16).toString() !== this.source.chainId) {
        throw new Error(
          `Connected to a different chain (chainId : ${chainId}). Expected chainId === ${this.source.chainId}`
        );
      }
      if (this.source.genesisHash && !this.config.skipGenesisCheck) {
        const genesisBlock = yield this.provider.request({ method: "eth_getBlockByNumber", params: ["earliest", false] });
        if (!genesisBlock) {
          throw new Error(
            `Cannot fetch genesis Hash. Expected genesisHash === ${this.source.genesisHash}`
          );
        } else {
          const genesisHash = genesisBlock.hash;
          if (genesisHash !== this.source.genesisHash) {
            throw new Error(
              `Connected to a different chain (genesisHash: ${genesisHash}). Expected genesisHash === ${this.source.genesisHash}`
            );
          }
        }
      }
      let currentLastSync = void 0;
      yield this._onLoad("Loading");
      const processorHash = this.processor.getVersionHash();
      const loaded = yield this.processor.load(this.source, this.config.stream);
      if (loaded) {
        const { lastSync: loadedLastSync, state } = loaded;
        if (processorHash === loadedLastSync.context.processor && this.indexerMatches(loadedLastSync.lastToBlock, loadedLastSync.context)) {
          currentLastSync = loadedLastSync;
          this._onStateUpdated(state);
        } else {
          namedLogger2.log(`STATE DISCARDED AS PROCESSOR CHANGED`);
          if (((_a = this.config) == null ? void 0 : _a.logLevel) && this.config.logLevel >= 1) {
            console.log(`State Discarded: processor changed`, JSON.stringify({
              sourceHashes: this.sourceHashes,
              loadedSourceHashes: loaded.lastSync.context.source,
              streamConfigHash: this.streamConfigHash,
              loadedStreamConfigHash: loaded.lastSync.context.config,
              processorHash,
              loadedProcessorHash: loadedLastSync.context.processor
            }, null, 2));
          }
          yield this.processor.clear();
        }
      }
      if (!currentLastSync) {
        currentLastSync = this.freshLastSync(processorHash);
        this.lastSync = currentLastSync;
        this._onLastSyncUpdated();
        if (this.config.keepStream) {
          yield this._onLoad("FetchingEventStream");
          const fromBlock = this.defaultFromBlock;
          const existingStreamData = yield this.config.keepStream.fetchFrom(this.source, fromBlock);
          if (existingStreamData) {
            const { eventStream: eventsFetched, lastSync: lastSyncFetched } = existingStreamData;
            lastSyncFetched.lastFromBlock = fromBlock;
            if (this.indexerMatches(lastSyncFetched.lastToBlock, lastSyncFetched.context)) {
              currentLastSync.context.processor = processorHash;
              if (eventsFetched.length > 0) {
                yield this._onLoad("ProcessingEventStream");
                yield this.feed(eventsFetched, lastSyncFetched);
              }
            } else {
              yield this.config.keepStream.clear(this.source);
            }
          } else {
            yield this.config.keepStream.clear(this.source);
          }
        }
      } else {
        if (this.config.keepStream) {
          const existingStreamData = yield this.config.keepStream.fetchFrom(
            this.source,
            getFromBlock(currentLastSync, this.defaultFromBlock, this.finality)
          );
          if (existingStreamData) {
            const { lastSync: lastSyncFetched } = existingStreamData;
            if (!this.indexerMatches(lastSyncFetched.lastToBlock, lastSyncFetched.context)) {
              yield this.config.keepStream.clear(this.source);
            }
          }
        }
        this.lastSync = currentLastSync;
        this._onLastSyncUpdated();
      }
      yield this._onLoad("Loaded");
      return this.lastSync;
    });
  }
  promiseToFeed(_0, _1) {
    return __async(this, arguments, function* (params, { unlessCancelled }) {
      const newEvents = params.newEvents;
      const lastSyncFetched = params.lastSyncFetched;
      if (!this.lastSync) {
        this.lastSync = this.freshLastSync(this.processor.getVersionHash());
        this._onLastSyncUpdated();
      }
      const { eventStream, newLastSync } = generateStreamToAppend(this.lastSync, this.defaultFromBlock, newEvents, {
        newLatestBlock: lastSyncFetched.latestBlock,
        newLastToBlock: lastSyncFetched.lastToBlock,
        newLastFromBlock: lastSyncFetched.lastFromBlock,
        finality: this.finality
      });
      const eventsInGroups = groupLogsPerBlock(eventStream);
      const batchSize = this.config.feedBatchSize;
      let currentLastSync = __spreadValues({}, newLastSync);
      while (eventsInGroups.length > 0) {
        const list = [];
        while (eventsInGroups.length > 0 && list.length < batchSize) {
          const blockGroup = eventsInGroups.shift();
          if (blockGroup) {
            list.push(...blockGroup.events);
          }
        }
        if (list.length > 0) {
          currentLastSync.lastToBlock = list[list.length - 1].blockNumber;
          const outcome = yield unlessCancelled(this.processor.process(list, currentLastSync));
          this.lastSync = currentLastSync;
          this._onLastSyncUpdated();
          this._onStateUpdated(outcome);
          yield unlessCancelled(wait(1e-3));
        }
      }
      this.lastSync = newLastSync;
      return this.lastSync;
    });
  }
  promiseToSave(params) {
    return __async(this, null, function* () {
      var _a;
      const { eventStream, source, lastSync } = params;
      let streamNotYetSaved = this._save.getContext();
      if (!streamNotYetSaved) {
        streamNotYetSaved = [];
        this._save.setContext(streamNotYetSaved);
      }
      streamNotYetSaved.push(...eventStream);
      try {
        yield (_a = this.config.keepStream) == null ? void 0 : _a.saveNewEvents(source, {
          eventStream: streamNotYetSaved,
          lastSync
        });
        streamNotYetSaved.splice(0, streamNotYetSaved.length);
      } catch (e) {
        namedLogger2.error(`could not save stream, ${e}`);
      }
    });
  }
  promiseToIndex(_0) {
    return __async(this, arguments, function* ({ unlessCancelled }) {
      if (!this.lastSync) {
        namedLogger2.info(`load lastSync...`);
        yield this.load();
      }
      const before_fetch_chainIdAsHex = yield unlessCancelled(this.provider.request({ method: "eth_chainId" }));
      const before_fetch_chainId = parseInt(before_fetch_chainIdAsHex.slice(2), 16).toString();
      if (before_fetch_chainId !== this.source.chainId) {
        throw new Error(`chainId changed before fetch`);
      }
      const previousLastSync = this.lastSync;
      const { lastSync: newLastSync, eventStream } = yield this.fetchLogsFromProvider(previousLastSync, unlessCancelled);
      const chainIdAsHex = yield unlessCancelled(this.provider.request({ method: "eth_chainId" }));
      const chainId = parseInt(chainIdAsHex.slice(2), 16).toString();
      if (chainId !== this.source.chainId) {
        throw new Error(`chainId changed after fetch`);
      }
      const outcome = yield unlessCancelled(this.processor.process(eventStream, newLastSync));
      yield this.save(this.source, eventStream, newLastSync);
      this.lastSync = newLastSync;
      this._onLastSyncUpdated();
      if (eventStream.length > 0) {
        this._onStateUpdated(outcome);
      }
      return this.lastSync;
    });
  }
  fetchLogsFromProvider(lastSync, unlessCancelled) {
    return __async(this, null, function* () {
      const lastUnconfirmedBlocks = lastSync.unconfirmedBlocks;
      const fromBlock = getFromBlock(lastSync, this.defaultFromBlock, this.finality);
      const latestBlock = yield unlessCancelled(getBlockNumber(this.provider));
      let toBlock = latestBlock;
      if (fromBlock > toBlock) {
        namedLogger2.info(`no new block`);
        return { lastSync, eventStream: [] };
      }
      const { events: eventsFetched, toBlockUsed: newToBlock } = yield this.logEventFetcher.getLogEvents(
        {
          fromBlock,
          toBlock
        },
        unlessCancelled
      );
      toBlock = newToBlock;
      const blockTimestamps = {};
      const transactions = {};
      let anyFetch = false;
      const blockHashes = [];
      const transactionHashes = [];
      let lastBlock;
      let lastTransactionHash;
      for (const event of eventsFetched) {
        let fetchTransaction = false;
        let fetchBlock = false;
        if (this.config.stream.alwaysFetchTransactions) {
          if (lastTransactionHash !== event.transactionHash) {
            fetchTransaction = true;
          }
        }
        if (this.config.stream.alwaysFetchTimestamps) {
          if (!lastBlock || event.blockNumber > lastBlock) {
            fetchBlock = true;
          }
        }
        if (fetchTransaction) {
          lastTransactionHash = event.transactionHash;
          transactionHashes.push(event.transactionHash);
        }
        if (fetchBlock) {
          lastBlock = event.blockNumber;
          blockHashes.push(event.blockHash);
        }
      }
      if (blockHashes.length > 0) {
        namedLogger2.info(`fetching a batch of  ${blockHashes.length} blocks...`);
        const blocks = yield this.getBlocks(blockHashes, unlessCancelled);
        namedLogger2.info(`...got  ${blocks.length} blocks back`);
        for (let i = 0; i < blockHashes.length; i++) {
          blockTimestamps[blockHashes[i]] = blocks[i].timestamp;
        }
        anyFetch = true;
      }
      if (transactionHashes.length > 0) {
        namedLogger2.info(`fetching a batch of ${transactionHashes.length} transactions...`);
        const transactionReceipts = yield this.getTransactions(transactionHashes, unlessCancelled);
        namedLogger2.info(`...got ${transactionReceipts.length} transactions back`);
        for (let i = 0; i < transactionHashes.length; i++) {
          transactions[transactionHashes[i]] = transactionReceipts[i];
        }
        anyFetch = true;
      }
      if (anyFetch) {
        for (const event of eventsFetched) {
          event.transaction = transactions[event.transactionHash];
          event.blockTimestamp = blockTimestamps[event.blockHash];
        }
      }
      const { eventStream, newLastSync } = generateStreamToAppend(lastSync, this.defaultFromBlock, eventsFetched, {
        // TODO investigate: why need to type it here ?
        newLatestBlock: latestBlock,
        newLastToBlock: toBlock,
        newLastFromBlock: fromBlock,
        finality: this.finality
      });
      return { lastSync: newLastSync, eventStream };
    });
  }
  getBlocks(blockHashes, unlessCancelled) {
    return __async(this, null, function* () {
      if (this.config.providerSupportsETHBatch) {
        return getBlockDataFromMultipleHashes(this.provider, blockHashes);
      } else {
        const result = [];
        for (const blockHash of blockHashes) {
          namedLogger2.info(`getting block ${blockHash}...`);
          const actualBlock = yield unlessCancelled(getBlockData(this.provider, blockHash));
          result.push(actualBlock);
        }
        return result;
      }
    });
  }
  getTransactions(transactionHashes, unlessCancelled) {
    return __async(this, null, function* () {
      if (this.config.providerSupportsETHBatch) {
        return getTransactionDataFromMultipleHashes(this.provider, transactionHashes);
      } else {
        const result = [];
        for (const transactionHash of transactionHashes) {
          namedLogger2.info(`getting block ${transactionHash}...`);
          const tx = yield unlessCancelled(getTransactionData(this.provider, transactionHash));
          result.push(tx);
        }
        return result;
      }
    });
  }
  indexerMatches(lastToBlock, context) {
    return indexerMatches(this.sourceHashes, this.streamConfigHash, lastToBlock, context);
  }
  freshLastSync(processorHash) {
    if (!this.sourceHashes || !this.streamConfigHash) {
      throw new Error(`no sourceHashes or configHash computed, please load first`);
    }
    return {
      context: { source: this.sourceHashes, config: this.streamConfigHash, processor: processorHash },
      lastToBlock: 0,
      lastFromBlock: 0,
      latestBlock: 0,
      unconfirmedBlocks: []
    };
  }
  _onStateUpdated(outcome) {
    if (this.onStateUpdated) {
      try {
        this.onStateUpdated(outcome);
      } catch (e) {
      }
    }
  }
  _onLastSyncUpdated() {
    if (this.lastSync && this.onLastSyncUpdated) {
      try {
        this.onLastSyncUpdated(this.lastSync);
      } catch (e) {
      }
    }
  }
  _onLoad(state) {
    return __async(this, null, function* () {
      if (this.onLoad) {
        try {
          yield this.onLoad(state);
        } catch (e) {
        }
      }
    });
  }
};
function indexerMatches(indexerSourceHashes, indexerConfigHash, lastToBlock, context) {
  if (context.config !== indexerConfigHash) {
    return false;
  }
  for (let i = 0; i < indexerSourceHashes.length; i++) {
    const indexerSourceItem = indexerSourceHashes[i];
    const fetchedSourceItem = context.source[i];
    if (fetchedSourceItem) {
      if (indexerSourceItem.hash !== fetchedSourceItem.hash) {
        return false;
      }
    } else {
      if (indexerSourceItem.startBlock <= lastToBlock) {
        return false;
      }
    }
  }
  return true;
}
export {
  EthereumIndexer,
  simple_hash
};
